import React, { useState } from "react";
import { useContextSelector } from "use-context-selector";
import AuthContext from "../../context/AuthContext";
import { isNumber } from "lodash";
import RenderOdds from "./RenderOdds";
import BetSlipContext from "../../context/BetSlipContext";
import { formatWithCommas } from "../../Utils/Toast";
import useScrollToItem from "../../component/Scroll";
import useSelectionLogic from "../useLogic/useSelectionLogic";

const Selection = ({
  runner,
  backOdds,
  layOdds,
  oldBack,
  oldLay,
  profileData,
  marketName,
  detail,
  ms,
  position,
  typeGame,
  user,
  marketId,
  totalMatched,
}) => {
  const showBetDialog = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.showBetDialog;
  });

  const betSlipObject = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.betSlipObject;
  });

  const [localLimit, setLocalLimit] = useState({});
  const scrollToItem = useScrollToItem("#header"); // Pass header selector
  const { handelChange, checkArrays } = useSelectionLogic({
    user: user,
    profileData: profileData,
    detail: detail,
    typeGame: typeGame,
    marketId: marketId,
    totalMatched: totalMatched,
    setLocalLimit,
    scrollToItem,
    localLimit,
    marketName,
  });

  return (
    <div>
      <div className="s-bg-white dark:s-bg-black-800 s-shadow-2sm">
        <div className="s-px-2">
          <div className="s-py-1px s-flex s-justify-between s-items-center">
            <div className="s-flex-1" />
            <div className="s-w-129px s-flex s-gap-1px s-text-14px s-font-bold s-leading-140">
              <div className="s-w-64px s-text-center s-text-global-font-default-light dark:s-text-global-font-default-dark">
                Back
              </div>
              <div className="s-w-64px s-text-center s-text-global-font-default-light dark:s-text-global-font-default-dark">
                Lay
              </div>
            </div>
          </div>
          <div>
            <div className="s-relative">
              <div className="s-space-y-px">
                {runner?.map((item, index) => {
                  const odds_back = backOdds?.filter(
                    (todd) => todd.ri === item.SelectionId
                  );
                  const odds_lay = layOdds?.filter(
                    (todd) => todd.ri === item.SelectionId
                  );
                  const old_back = oldBack?.filter(
                    (todd) => todd.ri === item.SelectionId
                  );
                  const old_lay = oldLay?.filter(
                    (todd) => todd.ri === item.SelectionId
                  );
                  let disabelBack =
                    "lockBackBets" in item ? item?.lockBackBets : false;
                  let disabelLay =
                    "lockLayBets" in item ? item?.lockLayBets : false;
                  let disableFull = checkArrays(
                    odds_back?.slice(0, 1),
                    odds_lay?.slice(0, 1),
                    localLimit
                  );
                  let showPosition =
                    (isNumber(item?.position) &&
                      position?.length > 0 &&
                      Math.abs(item?.position) > 0) ||
                    (Math.abs(item?.newPosition) >= 0 &&
                      showBetDialog &&
                      betSlipObject?.playType == typeGame &&
                      marketId == betSlipObject?.object?.newMarketId);

                  return (
                    <div className="s-bg-black-100 dark:s-bg-black-700">
                      <div className="s-flex s-justify-start s-items-center">
                        <div className="s-px-7px s-flex-1 s-h-full s-flex s-flex-col s-justify-center s-text-global-font-default-light dark:s-text-global-font-default-dark">
                          <p className="s-text-17px s-font-bold s-leading-120 s-break-all">
                            {item?.RunnerName || item?.runnerName}
                          </p>

                          {showPosition && (
                            <div
                              className="s-text-12px s-leading-150 s-flex"
                              data-testid="forecast"
                            >
                              {isNumber(item?.position) &&
                                position?.length > 0 &&
                                Math.abs(item?.position) > 0 && (
                                  <span
                                    className={`s-flex s-items-center s-text-forecast-${
                                      item?.position > 0 ? "up" : "down"
                                    }-text`}
                                    data-testid="estimate-forecast"
                                  >
                                    <span className="s-icon-arrow-left s-rotate-180 s-flex s-text-6px s-mx-0.5" />{" "}
                                    {isNumber(item?.position) &&
                                    Math.abs(item?.position) > 0
                                      ? item?.position > 0
                                        ? Math?.abs(item?.position).toFixed(2)
                                        : `(${Math.abs(item?.position).toFixed(
                                            2
                                          )})`
                                      : ""}
                                  </span>
                                )}
                              {Math.abs(item?.newPosition) >= 0 &&
                                showBetDialog &&
                                betSlipObject?.playType == typeGame &&
                                marketId ==
                                  betSlipObject?.object?.newMarketId && (
                                  <span
                                    className={`s-flex s-items-center s-text-forecast-${
                                      item?.newPosition > 0 ? "up" : "down"
                                    }-text`}
                                    data-testid="estimate-forecast"
                                  >
                                    <span className="s-icon-arrow-left s-rotate-180 s-flex s-text-6px s-mx-0.5" />{" "}
                                    {item?.newPosition > 0
                                      ? Math.abs(item?.newPosition).toFixed(2)
                                      : `(${Math.abs(item?.newPosition).toFixed(
                                          2
                                        )})`}
                                  </span>
                                )}
                            </div>
                          )}
                        </div>
                        <RenderOdds
                          component={typeGame}
                          index={index}
                          marketName={marketName}
                          item={item}
                          disabelBack={disabelBack}
                          oldBack={old_back}
                          oldLay={old_lay}
                          disableFull={disableFull}
                          disabelLay={
                            detail?.market == "Win" ? true : disabelLay
                          }
                          isInPlay={
                            ["Win", "Winner"].includes(detail?.market)
                              ? true
                              : detail?.status == "in_play"
                              ? true
                              : false
                          }
                          handelChange={handelChange}
                          odds_lay={odds_lay}
                          odds_back={odds_back}
                          limit={localLimit}
                          ms={ms}
                          betType={betSlipObject?.betType}
                          active={
                            showBetDialog &&
                            marketId == betSlipObject?.newMarketId &&
                            item?.SelectionId ==
                              betSlipObject?.object?.SelectionId &&
                            typeGame == betSlipObject?.playType
                          }
                        />
                      </div>
                    </div>
                  );
                })}
              </div>
              {ms != 1 && (
                <div className="s-absolute s-right-0 s-top-0 s-flex s-justify-center s-items-center s-w-129px s-h-full s-bg-black-600 dark:s-bg-black-800 s-opacity-80 s-text-11px s-text-white s-rounded-3px s-z-20" />
              )}
            </div>
            <div className="s-py-4px s-flex s-justify-between s-items-center s-min-h-30px">
              <div className="s-px-4px s-py-5px s-flex s-gap-3px s-justify-center s-items-center s-rounded s-bg-secondary s-text-global-font-on-dark">
                <span className="s-icon-graph s-text-14px" />
                <span className="s-text-11px"> Market Depth </span>
              </div>
              <div
                className="s-flex s-gap-3px s-items-center s-text-black-600 dark:s-text-black-400"
                data-testid="betLimit"
              >
                <span className="s-icon-min-max s-text-14px" />
                <span className="s-text-12px">Min/Max</span>
                <span className="s-text-12px s-font-bold">
                  {formatWithCommas(localLimit?.minAmount)}/
                  {formatWithCommas(localLimit?.maxAmount)}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default React.memo(Selection);
